import CalidadServicio from './CalidadServicio';
export default CalidadServicio;
